import React from 'react'
import AddRemove from '../components/AddRemove'

const EditAnimal = () => {
  return (
    <div>
        <AddRemove/>
    </div>
  )
}

export default EditAnimal